<script>
import TablePage from '@/found/components/table_page';
// 新增用户
import addUser from '../user_management/form/add_user/index';

export default {
  name: 'user_pending',
  extends: TablePage,
  data() {
    return {
    };
  },
  components: {
    addUser,
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { status } = row;
      if (code === 'process_immediately' && status !== '0') {
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (val.code === 'process_immediately') {
        this.formName = 'addUser';
        this.formConfig = { ...row, code: val.code };
        if (row.businessType === '0') {
          this.modalConfig.title = '入职';
        } else if (row.businessType === '1') {
          this.modalConfig.title = '调岗';
        } else if (row.businessType === '2') {
          this.modalConfig.title = '离职';
        } else {
          this.modalConfig.title = '企业用户';
        }
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('main_list');
  },
};
</script>
